import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, urlBackend } from "@/shared";
import { IDataMovimientoInventario, IDataMovimientoInventarioParams, MovimientoInventario, UseFetchEnabledParams } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

///* Kardex

const { get, post } = erpApi();

///* CREAR MOVIMIENTO DE INVENTARIO
export const useCreateMovimientoInventario = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: postMovimientoInventario,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['movimiento-inventario'] });
      setAlert(true, data.message, data.status);
    },
  });
};

export const postMovimientoInventario = async (data: IDataMovimientoInventario) => {
  const resp = await post<IDataMovimientoInventario>(`${urlBackend}api/v1/movimiento-inventario/`, data, true);
  return resp;
};

///* OBTENER MOVIMIENTO DE INVENTARIO

export const useFetchMovimientoInventario = ({ enabled = false, params }: UseFetchEnabledParams<IDataMovimientoInventarioParams>) => {
  return useQuery({
    queryKey: ['movimiento-inventario', ...Object.values(params || {})],
    queryFn: async () => {
      return await getMovimientoInventario(params);
    },
    enabled,
    refetchOnWindowFocus: false,
  })
};

///* MOVIMIENTO DE INVENTARIO Y KARDEX
export const getMovimientoInventario = async (params?: IDataMovimientoInventarioParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<MovimientoInventario>(`${urlBackend}api/v1/movimiento-inventario/?${queryParams}`, true);
  return resp;
};


export const useFetchMovimientoInventarioExcel = ({ enabled = false, params }: UseFetchEnabledParams<IDataMovimientoInventarioParams>) => {
  return useQuery({
    queryKey: ['movimiento-inventario', ...Object.values(params || {})],
    queryFn: async () => {
      return await getMovimientoInventarioExcel(params);
    },
    enabled,
    refetchOnWindowFocus: false,
  })
};

///* MOVIMIENTO DE INVENTARIO Y KARDEX
export const getMovimientoInventarioExcel = async (params?: IDataMovimientoInventarioParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<MovimientoInventario>(`${urlBackend}api/v1/movimiento-inventario/excel/?${queryParams}`, true);
  return resp;
};


///* MOVIMIENTO DE INVENTARIO Y KARDEX ASYNC
export const getMovimientoInventarioExcelAsync = async (params?: IDataMovimientoInventarioParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<any>(`${urlBackend}api/v1/movimiento-inventario/excel-async/?${queryParams}`, true);
  return resp;
};


/// Generacion de excel generico
export const getReporteExcelCeleryAsync = async (path: string, params?: any) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<{ task_id: string }>(`${urlBackend}api/v1/${path}/?${queryParams}`, true);
  return resp;
};